import { NeutralColors } from "../../constants/colors";
import { DEFAULT_PALETTE } from "../../constants/palettes";
import { links } from "./links";
export var colors = {
  positive: '#787E89',
  negative: NeutralColors.White
};
export var backgroundColors = {
  positive: NeutralColors.White,
  negative: NeutralColors.Ink
};
export var LAYOUT_TYPES = {
  DEFAULT: 'default',
  COMPACT: 'compact'
};
export var defaultProps = {
  pageLocales: [],
  links: links,
  palette: DEFAULT_PALETTE,
  layoutType: LAYOUT_TYPES.DEFAULT,
  onLinkClick: function onLinkClick() {},
  onLinksAccordionOpened: function onLinksAccordionOpened() {},
  onCookiePolicySettingsClick: function onCookiePolicySettingsClick() {},
  onLanguageSwitcherOptionClick: function onLanguageSwitcherOptionClick() {}
};